export const isDateFuture = (date) => date === null || new Date(date) > new Date();
